import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccessList } from '../../../../utils/api-helper';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../../../redux/slices/loader';
import notification from '../../../notification';

import ROUTES from '../../../../constants/ROUTES';
import Button from '../../../Button';
import PasswordMinimalistic from '../../../../assets/PasswordMinimalistic.svg';
import Signature from '../../../../assets/Signature.svg';
import DocumentTypeManagement from '../../../../assets/DocumnetTypeManagment.svg';
import ProductNameManagement from '../../../../assets/ProductNameManagement.svg';
import GroupOfPersonsWhite from '../../../../assets/GroupOfPersonsWhite.svg';
import PeoplesWhite from '../../../../assets/PeoplesWhite.svg';
import { useSelector } from 'react-redux';
import { USERSTYPES } from '../../../../constants/ROLES';

const ControlCenter = ({ closeModal }) => {
  const { userDetails } = useSelector((state) => state?.userDetails);
  const [accessList, setAccessList] = useState([]);

  const dispatch = useDispatch();
  const navigation = useNavigate();

  const initLoading = async () => {
    try {
      dispatch(setLoader(true));
      const getAccessListResp = await getAccessList();
      setAccessList(getAccessListResp?.data?.accessList);

      dispatch(setLoader(false));
    } catch (error) {
      dispatch(setLoader(false));
      notification(
        'error',
        error?.response?.data?.error ||
          'Error while loading access control settings.'
      );
    }
  };

  useEffect(() => {
    initLoading();
  }, []);

  return (
    <div className='flex flex-col h-full gap-y-2'>
      {accessList?.includes('People') && (
        <Button
          icon={PeoplesWhite}
          title={'People'}
          iconStyle={'mr-2 w-4 h-4'}
          textStyle={'text-sm'}
          buttonStyle={'rounded-lg bg-transparent'}
          handleClick={() => {
            closeModal();
            navigation(ROUTES.people);
          }}
        />
      )}

      {accessList?.includes('Teams') && (
        <Button
          icon={GroupOfPersonsWhite}
          title={'Teams'}
          iconStyle={'mr-2'}
          textStyle={'text-sm'}
          buttonStyle={'rounded-lg bg-transparent'}
          handleClick={() => {
            closeModal();
            navigation(ROUTES.teams);
          }}
        />
      )}

      {/* Allow Only Admin to View */}
      {USERSTYPES.ADMIN === userDetails?.user?.role?.label && (
        <>
          <Button
            icon={PasswordMinimalistic}
            title={'Recording Jurisdiction Credentials'}
            iconStyle={'mr-2'}
            textStyle={'text-sm'}
            buttonStyle={'rounded-lg bg-transparent'}
            handleClick={() => {
              closeModal();
              navigation(ROUTES.jurisdictionCredentials);
            }}
          />

          <Button
            icon={Signature}
            title={'Signature Management'}
            iconStyle={'mr-2'}
            textStyle={'text-sm'}
            buttonStyle={'rounded-lg bg-transparent'}
            handleClick={() => {
              closeModal();
              navigation(ROUTES.emailSignature);
            }}
          />

          <Button
            icon={DocumentTypeManagement}
            title={'Document Type Management'}
            iconStyle={'mr-2 w-5 h-5'}
            textStyle={'text-sm'}
            buttonStyle={'rounded-lg bg-transparent'}
            handleClick={() => {
              closeModal();
              navigation(ROUTES.documentTypeManagement);
            }}
          />

          <Button
            icon={ProductNameManagement}
            title={'Client-Facing Product Names'}
            iconStyle={'mr-2 w-5 h-5'}
            textStyle={'text-sm text-left'}
            buttonStyle={'rounded-lg bg-transparent'}
            handleClick={() => {
              closeModal();
              navigation(ROUTES.productNameManagement);
            }}
          />
        </>
      )}
    </div>
  );
};

export default ControlCenter;
